import { on } from 'delegated-events'

const handlePhotoGalleryTrigger = (e) => {
  e.preventDefault()

  const lightGallery = window.lightGallery
  const gallery = e.target.closest('[data-photo-gallery]')
  const galleryIndex = gallery.dataset.galleryIndex
  const startIndex = galleryIndex === undefined ? 0 : parseInt(galleryIndex) - 1
  const galleryData = JSON.parse(gallery.dataset.photoGallery)

  lightGallery(gallery, {
    index: parseInt(startIndex),
    dynamic: true,
    dynamicEl: galleryData,
    thumbnail: true,
    download: false,
  })

  gallery.addEventListener(
    'onCloseAfter',
    () => {
      const uid = gallery.getAttribute('lg-uid')

      if (Object.prototype.hasOwnProperty.call(window.lgData, uid)) {
        window.lgData[uid].destroy(true)
      }
    },
    { once: true }
  )
}

const setupPhotoGallery = async () => {
  import('lightgallery.js/dist/css/lightgallery.css')
  await import('lightgallery.js/dist/js/lightgallery.js')
  import('lg-thumbnail.js/dist/lg-thumbnail.js')
}

if (document.querySelector('[data-photo-gallery]')) {
  setupPhotoGallery()

  on('click', '[data-gallery-trigger]', handlePhotoGalleryTrigger)
}
